import { type IconSize, type IconSizeToken, SIZE_CLASS } from "./sizes";

export function isIconSizeToken(size: IconSize): size is IconSizeToken {
  return typeof size === "string" && Object.hasOwn(SIZE_CLASS, size);
}
